import React, { useState } from 'react';
import { ShieldCheckIcon, ClockIcon, LockIcon, ZapIcon } from 'lucide-react';
import { Section, FadeIn, CountdownTimer } from './Shared';
import { motion } from 'framer-motion';
const PLANS = [{
  id: 'rosegold',
  emoji: '🏆',
  name: 'ROSE GOLD EDITION™',
  desc: '6 Tomos + 6 Bonos + Periodización + Academia Digital',
  oldPrice: '$43.990',
  price: '$27.990',
  savings: 'AHORRÁS $16.000',
  popular: true,
  url: 'https://checkout.rincondigital.shop/cart/54038795419923:1'
}, {
  id: 'standard',
  emoji: '📘',
  name: 'GAP 360',
  desc: '6 Tomos + 6 Bonos',
  oldPrice: '$34.990',
  price: '$19.990',
  savings: null,
  popular: false,
  url: 'https://checkout.rincondigital.shop/cart/54038795223315:1'
}];
export const Pricing = () => {
  const [selected, setSelected] = useState('rosegold');
  const selectedPlan = PLANS.find(p => p.id === selected)!;
  return <Section bg="charcoal" id="pricing" data-id="element-146">
      <div className="max-w-lg mx-auto" data-id="element-147">
        <FadeIn className="text-center mb-5 md:mb-8" data-id="element-148">
          <div className="inline-block bg-red-500/20 text-red-400 font-bold px-4 py-1.5 rounded-full text-xs uppercase tracking-wider mb-3 md:mb-4 animate-pulse" data-id="element-149">
            ⏳ PRECIO DE LANZAMIENTO TERMINA EN:
          </div>
          <CountdownTimer data-id="element-150" />
          <p className="text-gray-400 font-semibold mt-2 text-xs md:text-sm" data-id="element-151">
            Después sube $8.000 ARS y no vuelve a bajar.
          </p>

          <div className="max-w-sm mx-auto mt-3 md:mt-5" data-id="element-152">
            <div className="flex justify-between text-[10px] md:text-xs font-bold text-gray-400 mb-1.5" data-id="element-153">
              <span className="flex items-center gap-1" data-id="element-154">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-155"></span>
                Cupos al precio de lanzamiento
              </span>
              <span data-id="element-156">68% tomados</span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2" data-id="element-157">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.5,
              delay: 0.5
            }} className="bg-red-500 h-2 rounded-full" data-id="element-158"></motion.div>
            </div>
          </div>
        </FadeIn>

        <FadeIn className="text-center mb-4 md:mb-6" data-id="element-159">
          <h2 className="text-xl md:text-3xl font-extrabold text-white mb-1" data-id="element-160">
            Elegí tu GAP 360:
          </h2>
          <p className="text-gray-400 font-medium text-xs md:text-sm" data-id="element-161">
            Ambas opciones incluyen los 6 bonos estratégicos
          </p>
        </FadeIn>

        {/* Ticket selection */}
        <FadeIn className="space-y-2.5 md:space-y-3 mb-5 md:mb-6" data-id="element-162">
          {PLANS.map(plan => {
          const isSelected = selected === plan.id;
          return <button key={plan.id} onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-xl md:rounded-2xl p-3 md:p-4 border-2 transition-all duration-200 relative ${plan.popular ? isSelected ? 'border-gold bg-gold/5' : 'border-gold/40 bg-white/5' : isSelected ? 'border-gray-400 bg-white/10' : 'border-white/10 bg-white/5'}`} data-id="element-163">
                <div className="flex items-start gap-3" data-id="element-164">
                  {/* Radio */}
                  <div className={`w-5 h-5 rounded-full border-2 shrink-0 mt-0.5 flex items-center justify-center ${isSelected ? plan.popular ? 'border-gold' : 'border-white' : 'border-gray-500'}`} data-id="element-165">
                    {isSelected && <div className={`w-2.5 h-2.5 rounded-full ${plan.popular ? 'bg-gold' : 'bg-white'}`} data-id="element-166"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-167">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-168">
                      <span className="text-base md:text-lg font-extrabold text-white" data-id="element-169">
                        {plan.emoji} {plan.name}
                      </span>
                    </div>
                    {plan.popular && <div className="flex items-center gap-2 mt-1.5 flex-wrap" data-id="element-170">
                        <span className="bg-gold text-charcoal font-bold px-2 py-0.5 rounded text-[10px] md:text-xs uppercase" data-id="element-171">
                          ⭐ MÁS ELEGIDO
                        </span>
                        {plan.savings && <span className="bg-green-500/20 text-green-400 font-bold px-2 py-0.5 rounded text-[10px] md:text-xs" data-id="element-172">
                            {plan.savings}
                          </span>}
                      </div>}
                    <p className="text-gray-400 text-[11px] md:text-xs mt-1" data-id="element-173">
                      {plan.desc}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right shrink-0" data-id="element-174">
                    <p className="text-gray-500 line-through text-[11px] md:text-xs font-bold" data-id="element-175">
                      {plan.oldPrice}
                    </p>
                    <p className={`text-xl md:text-2xl font-extrabold ${plan.popular ? 'text-gold' : 'text-white'}`} data-id="element-176">
                      {plan.price}
                    </p>
                  </div>
                </div>
              </button>;
        })}
        </FadeIn>

        {/* CTA Button */}
        <FadeIn data-id="element-177">
          <motion.a href={selectedPlan.url} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-gradient-to-r from-gold to-yellow-500 text-charcoal font-heading font-extrabold text-base md:text-lg py-3.5 md:py-4 px-6 rounded-xl md:rounded-2xl shadow-lg hover:shadow-xl transition-all text-center" data-id="element-178">
            SÍ, QUIERO MI GAP 360 →
          </motion.a>
          <p className="text-center text-gray-500 italic text-[11px] md:text-xs mt-2.5" data-id="element-179">
            {selected === 'rosegold' ? 'La opción más completa para instructoras que quieren dominar GAP y construir su negocio digital' : 'El sistema completo de clases GAP con todo lo que necesitás para empezar hoy'}
          </p>
        </FadeIn>

        {/* Trust badges */}
        <FadeIn className="mt-5 md:mt-8 bg-white/5 rounded-xl p-3 md:p-4 border border-white/10" data-id="element-180">
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-[10px] md:text-xs font-semibold text-gray-400" data-id="element-181">
            <div className="flex items-center gap-1" data-id="element-182">
              <LockIcon size={13} className="text-green-400" data-id="element-183" /> Pago seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-184">
              <ZapIcon size={13} className="text-yellow-400" data-id="element-185" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1" data-id="element-186">
              <ShieldCheckIcon size={13} className="text-coral" data-id="element-187" /> Garantía 7
              días
            </div>
            <div className="flex items-center gap-1" data-id="element-188">
              <span className="text-sm" data-id="element-189">💳</span> Mercado Pago
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};